// extracted by mini-css-extract-plugin
export default {"indexBox":"Index_indexBox__s5lfQ","mainContent":"Index_mainContent__TO1nK","resizeHandle":"Index_resizeHandle__adwYy"};